export default {
  'planAccounts.domain.code': 'Code',
  'planAccounts.domain.description': 'Description',
  'planAccounts.domain.hierarchy': 'Hierarchy',
  'planAccounts.domain.destination': 'Destination',
  'planAccounts.generateReport': 'Generate Report',
  'planAccounts.modal.report.title': 'Generate Report',
  'planAccounts.modal.report.buttons.pdf': 'Generate PDF',
  'planAccounts.modal.report.buttons.viewReport': 'View Report',
  'planAccounts.modal.report.buttons.csv': 'Generate CSV',
  'planAccounts.modal.report.form.description': 'Description',
  'planAccounts.modal.report.form.destination': 'Nature',
  'planAccounts.modal.report.form.nature': 'Nature',
  'planAccounts.modal.report.form.destination.revenue': 'Income',
  'planAccounts.modal.report.form.destination.expense': 'Expenses',
  'planAccounts.modal.report.form.nature.income': 'Income',
  'planAccounts.modal.report.form.nature.expenses': 'Expenses',
  'planAccounts.modal.report.form.hierarchy': 'Hierarchy',
  'planAccounts.modal.report.form.hierarchy.synthetic': 'Synthetic',
  'planAccounts.modal.report.form.hierarchy.analitical': 'Analytical',
  'planAccounts.modal.general.new.title': 'New Plan Account',
  'planAccounts.modal.general.edit.title': 'Edit Plan Account',
  'planAccounts.modal.general.form.code': 'Code',
  'planAccounts.modal.general.form.description': 'Description',
  'planAccounts.modal.general.form.destination': 'Nature',
  'planAccounts.modal.general.form.destination.revenue': 'Revenue',
  'planAccounts.modal.general.form.destination.expense': 'Expenses',
  'planAccounts.modal.general.form.hierarchy': 'Hierarchy',
  'planAccounts.modal.general.form.hierarchy.syntetics': 'Synthetic',
  'planAccounts.modal.general.form.hierarchy.analitical': 'Analytical',
  'planAccounts.modal.report.form.hierarchy.analytical': 'Analytical',
  'planAccounts.modal.general.form.planType': 'Plan Type',
  'planAccounts.modal.general.form.planType.general': 'General',
  'planAccounts.modal.general.form.planType.tax': 'Tax',
  'planAccounts.modal.general.form.planType.transfer': 'Transfer',
  'planAccounts.modal.general.form.planType.commission': 'Commission',
  'planAccounts.modal.general.form.planType.estorno': 'Estorno',
  'planAccounts.modal.general.form.planType.tariff': 'Tariff',
  'planAccounts.modal.general.form.classification': 'Expense Type',
  'planAccounts.modal.general.form.classification.fixed': 'Fixed',
  'planAccounts.modal.general.form.classification.variable': 'Variable',
  'planAccounts.modal.general.form.classification.withoutclassification':
    'Without Classification',

  'planAccounts.create.error':
    'To create the chart of accounts, you need to create the mask in the settings. ',
  'planAccounts.create': 'Create New Plan Account',
  'planAccounts.create.notification.success': 'Success',
  'planAccounts.create.notification.successDescription':
    'Plan Account created.',

  'planAccounts.update': 'Update Plan Account',
  'planAccounts.update.notification.success': 'Success',
  'planAccounts.update.notification.successDescription':
    'Plan Account updated.',

  'planAccounts.remove': 'Remove Plan Account',
  'planAccounts.remove.alert': 'Do you really want to remove the plan account:',
  'planAccounts.remove.notification.success': 'Success',
  'planAccounts.remove.notification.successDescription':
    'Plan Account removed.',

  'planAccounts.filters.code': 'Code',
  'planAccounts.filters.description': 'Description',
  'planAccounts.filters.hierarchy': 'Hierarchy',
  'planAccounts.filters.destination': 'Destination',

  'planAccounts.status.message.success':
    'Chart of accounts status successfully changed!',

  'planAccounts.notification.generate.report.title':
    'Report generated successfully',
  'planAccounts.notification.generate.report.description':
    'Chart of Accounts Report Successfully Generated!',
};
